var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:({display: _vm.showBlackOver}),attrs:{"id":"black_over"}}),_vm._v(" "),_c('head-box',{attrs:{"bannerInfo":_vm.bannerInfo}}),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('footer-nav-bar'),_vm._v(" "),_c('login')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53f62100","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 